var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.description
    ? _c("p", { staticClass: "font-normal text-base text-gray-new" }, [
        _vm._v("No summary added."),
      ])
    : _c(
        "div",
        [
          _vm._l(
            _vm.descriptionParagraphs,
            function (descriptionParagraph, index) {
              return _c(
                "p",
                {
                  key: index,
                  staticClass:
                    "font-300 customLineH text-primary-black text-base mr-1",
                  class: _vm.getParagraphClasses(index),
                },
                [_vm._v(" " + _vm._s(descriptionParagraph) + " ")]
              )
            }
          ),
          _vm.shouldDescriptionBeShortened
            ? _c(
                "button",
                {
                  staticClass:
                    "inline-block text-primary-500 hover:underline focus:underline focus:outline-none text-label",
                  on: { click: _vm.toggleExpandDescription },
                },
                [_vm._v(_vm._s(_vm.expandButtonText) + " ")]
              )
            : _vm._e(),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }